
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, Inject, OnChanges, SimpleChanges, AfterViewInit, ChangeDetectorRef, ViewChild, ElementRef} from '@angular/core';

import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import { confirmRemoveFromList, TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
import { ControlContainer, NgForm } from '@angular/forms';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { BeneficiaryListComponent } from './beneficiary-list.component';
import { WorkflowComponent } from '../../workflow.component';
import { SecurityService } from '@infrastructure/Security/SecurityService';
//import { PrestacoesMorteValueObservableService } from '@infrastructure/Documents/PrestacoesPorMorteValueObserver';
import { BeneficiaryHelperService } from '@infrastructure/Beneficiaries/BeneficiaryHelperService';
import DateHelpers from '@infrastructure/DateHelpers';
import { isNotNullOrUndefinedOrEmpty} from '@infrastructure/objectUtils';
import { fromEvent, Subscription } from 'rxjs';
import { CommonDataService } from '@infrastructure/CommonData/CommonDataService';
import { DropdownsValues } from '@infrastructure/Dropdowns/const.dropdowns';
import { debounceTime, take } from 'rxjs/operators';
//import { BenefitChoosen } from '@infrastructure/Documents/benefit-choosen.enum';
import { BeneficiaryIdsService } from '@infrastructure/Beneficiaries/beneficiary-ids.service';
import { NifValidationService } from '@infrastructure/NifValidation/nif-validation.service';
import { LegalRepresentationState } from '../../../_infrastructure/Beneficiaries/legal-representation-state.service';

@Component({
  selector: 'beneficiary-list-table-edit',
  templateUrl: './beneficiary-list-table-edit.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})
export class BeneficiaryListTableEditComponent extends TableEditBase<models.BeneficiaryListVM> implements OnInit, OnDestroy{
  
  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.country)
  public countries: models.DimensionVM[];
  @CommonData(DomainCodes.nationality)
  public nationalities: models.DimensionVM[];
  @CommonData(DomainCodes.genders)
  public genders: models.DimensionVM[];
  @CommonData(DomainCodes.martialStatus)
  public maritalStatus: models.DimensionVM[];
  @CommonData(DomainCodes.identificationType)
  public documentTypes: models.DimensionVM[];
  @CommonData(DomainCodes.fiscalCategories)
  public fiscalCategories: models.DimensionVM[];
  @CommonData(DomainCodes.incomeHolding)
  public incomeHoldings: models.DimensionVM[];
  @CommonData(DomainCodes.bankAccountTypes)
  public bankAccountTypes: models.DimensionVM[];
  @CommonData(DomainCodes.studyLevel)
  public educationLevel: models.DimensionVM[];

  @Input() dropdowns: models.WorkflowDropdownsVM;
  @Input() isServiceOrFunerary: boolean;
  

  public personType: models.PersonTypeVM;
  public benefitType: models.BenefitTypeVM;
  public beneficiaryIdentification: models.BeneficiaryIdentificationVM;
  public beneficiaryContacts: models.BeneficiaryContactsVM;
  public deceasedRelationship: models.DeceasedRelationshipVM;
  public legalRepresentationIdentification: models.LegalRepresentationIdentificationVM;
  public taxInformation: models.TaxInformationVM;
  public payment: models.PaymentVM;
  public beneficiaryObservations: models.BeneficiaryObservationsVM;
  public notifications: models.NotificationsVM;

  public parentWorkflow: WorkflowComponent;
  public dataFalecimento: Date;
  public expandedRowIndex: number = null;

  // Estes valores têm que ser validado, pois ele vem no BE, e é um valor que é alterado todos os anos, ver a melhor maneira de receber este valor. Estes valores são de 2025
  public IASValue = 522.50
  public RMMG = 870
  //até aqui

  

  public maritalStatusValues = DropdownsValues.dropListMaritalStatus;
  public relationDeceasedValues = DropdownsValues.dropdownDeceasedRelationship;


  public mainSubscription: Subscription = new Subscription();
  public isCommonDataLoaded: boolean = false;

  //public benefitChoosen: BenefitChoosen;
  public instanceId: number;

  //StateRL
  public senderIsRL: boolean;
  public senderIsBeneficiary: boolean;
  public isBeneficiarySender: boolean;

  constructor(@Inject(BeneficiaryListComponent) private parent: Component,
    private modalService: ModalService, 
    private commonDataService: CommonDataService,
    private BeneficiaryHelperService: BeneficiaryHelperService,
    private beneficiaryIDsService: BeneficiaryIdsService,
    private nifValidationService: NifValidationService) {
    super(parent, modalService);
    const domains = [
      DomainCodes.domains,
      DomainCodes.yesNo,
      DomainCodes.country,
      DomainCodes.nationality,
      DomainCodes.genders,
      DomainCodes.martialStatus,
      DomainCodes.identificationType,
      DomainCodes.fiscalCategories,
      DomainCodes.incomeHolding,
      DomainCodes.bankAccountTypes,
      DomainCodes.studyLevel

    ];

    this.instanceId = this.parent['parentWorkflow']?.workflowInstanceId;
    this.mainSubscription.add(
      this.commonDataService.getDomains(domains).subscribe(
        (results: models.DomainVM[]) => {
          this.domains = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.domains).dimensions;
          this.yesNo = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.yesNo).dimensions;
          this.countries = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.country).dimensions;
          this.nationalities = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.nationality).dimensions;
          this.genders = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.genders).dimensions;
          this.maritalStatus = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.martialStatus).dimensions;
          this.documentTypes = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.identificationType).dimensions;
          this.fiscalCategories = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.fiscalCategories).dimensions;
          this.incomeHoldings = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.incomeHolding).dimensions;
          this.bankAccountTypes = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.bankAccountTypes).dimensions;
          this.educationLevel = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.studyLevel).dimensions;
          this.isCommonDataLoaded = true;
        }
      )
    );
  }


  ngOnInit(): void {
    super.ngOnInit();
    if (!!this.item) {
      const isOnlyRDFBenefit = this.item.reimbursementFuneralBenefit?.toString() == 'true' &&
        this.item.funeralAllowanceBenefit?.toString() != 'true' &&
        this.item.survivalPensionBenefit?.toString() != 'true';

      const isOnlySOBenefit = this.item.reimbursementFuneralBenefit?.toString() != 'true' &&
        this.item.funeralAllowanceBenefit?.toString() != 'true' &&
        this.item.survivalPensionBenefit?.toString() == 'true';

      const isOnlySMBenefit = this.item.reimbursementFuneralBenefit?.toString() != 'true' &&
        this.item.funeralAllowanceBenefit?.toString() == 'true' &&
        this.item.survivalPensionBenefit?.toString() != 'true';



     
      //ID do beneficiario
      const instance = (<models.WorkflowTemplateVM_PM>this.parent['parentWorkflow']?.workflowInstance);
      const isServiceOrFunerary = instance.StepSender.SenderQualification.isServiceOrFunerary.toString()=='true';
      this.beneficiaryIDsService.itemVerifyHasId(this.item, this.itemList, !isServiceOrFunerary);

      //PersonType
      this.personType = {
        personTypology: this.item.personTypology,
        personTypologyCode: this.item.personTypologyCode
      };

      //BenefitType
      this.benefitType = {
        funeralAllowanceBenefit: this.item.funeralAllowanceBenefit,
        reimbursementFuneralBenefit: this.item.reimbursementFuneralBenefit,
        survivalPensionBenefit: this.item.survivalPensionBenefit,
        funeralExpense: this.item.funeralExpense,
        livedWithDeceased: this.item.livedWithDeceased,
        SSReceived: this.item.SSReceived,
        SSDiscounts: this.item.SSDiscounts

      }

      //BeneficiaryIdentification
      this.beneficiaryIdentification = {
        beneficiaryName: this.item.beneficiaryName,
        dateOfBirth: this.item.dateOfBirth,
        nationality: this.item.nationality,
        gender: this.item.gender,
        civilStateDeathDate: this.item.civilStateDeathDate,
        civilState:this.item.civilState,
        identificationDocumentType: this.item.identificationDocumentType,
        identificationNumberFirst: this.item.identificationNumberFirst,
        identificationNumberLast: this.item.identificationNumberLast,
        NIF: this.item.NIF,
        NISS: this.item.NISS,
        financialService: this.item.financialService,
        hasNacPT: this.item.hasNacPT,
        entity: this.item.entity,
        isCertified: this.item.isCertified,
        auditKey: this.item.auditKey,
        financialServiceLast: this.item.financialServiceLast,
        hasNIFPT: this.item.hasNIFPT,
        notEditable: this.item.notEditable
      }

      //BeneficiaryContacts
      this.beneficiaryContacts = {
        countryCode: this.item.countryCode,
        address: this.item.address,
        postalCodeFirst: this.item.postalCodeFirst,
        postalCodeLast: this.item.postalCodeLast,
        postalDesignation: this.item.postalDesignation,
        postalCodeFull: this.item.postalCodeFull,
        locality: this.item.locality,
        telephone: this.item.telephone,
        mobileNumber: this.item.mobileNumber,
        email: this.item.email
      }
      
      //DeceasedRelationship
      this.deceasedRelationship = {
        deceasedRelationship: this.item.deceasedRelationship,
        otherDeceasedRelationship: this.item.otherDeceasedRelationship,
        startDateCohabitation: this.item.startDateCohabitation,
        marriageDate: this.item.marriageDate,
        hasCourtAlimony: this.item.hasCourtAlimony,
        alimonyValueDeathDate: this.item.alimonyValueDeathDate,
        hasChargeDeceased: this.item.hasChargeDeceased,
        monthlyncome: this.item.monthlyncome,
        hasIRSExemption: this.item.hasIRSExemption,
        scholarSituationDeathDate: this.item.scholarSituationDeathDate,
        educationLevelDeathDate: this.item.educationLevelDeathDate,
        registrationYear: this.item.registrationYear,
        activeProfessionalSituation: this.item.activeProfessionalSituation,
        startDateProfession: this.item.startDateProfession,
        income: this.item.income,
        professionalSituation: this.item.professionalSituation,
        hasIncapacity: this.item.hasIncapacity,
        hasSocialPension: this.item.hasSocialPension,
        socialPensionDate: this.item.socialPensionDate,
        hasJudicialInterdiction: this.item.hasJudicialInterdiction
      }

      //LegalRepresentationIdentification
      this.legalRepresentationIdentification = {
        hasLegalRepresentation: this.item.hasLegalRepresentation,
        legalRepresentationName: this.item.legalRepresentationName,
        representationType: this.item.representationType,
        rejectionReason: this.item.rejectionReason,
        stateRL: this.item.stateRL
      }

   

      this.senderIsRL = instance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true';
      this.senderIsBeneficiary = instance.StepSender.SenderQualification.isBeneficiary?.toString() == 'true';
      this.isBeneficiarySender = this.senderIsBeneficiary && this.item.beneficiaryID == 1;

      if (this.senderIsRL) {
        if (this.isBeneficiarySender) {
          this.legalRepresentationIdentification.legalRepresentationName = "";
        } else {
          this.legalRepresentationIdentification.legalRepresentationName = instance.StepSender.SenderIdentification.name;
        }

      }
      //taxInformation
      this.taxInformation = {
        irsTable: this.item.irsTable,
        irsTableCode: this.item.irsTableCode,
        desvalorizationPercentage: this.item.desvalorizationPercentage,
        revenueTitularityCode: this.item.revenueTitularityCode,
        entireRatePerOption: this.item.entireRatePerOption,
        dependentsWithoutDisability: this.item.dependentsWithoutDisability,
        dependentsWithDisability: this.item.dependentsWithDisability,
      }

      //payment
      this.payment = {
        bankAccount: this.item.bankAccount,
        iban: this.item.iban,
        isSoleHolder: this.item.isSoleHolder,
        coholderName: this.item.coholderName
      }

      //beneficiaryObservations
      this.beneficiaryObservations = {
        additionalObservations: this.item.additionalObservations
      }

      //notifications
      this.notifications = {
        emailNotification: this.item.emailNotification
      }
    }



  }


  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
  }
  
  public validacaoRLIndeferida(): boolean {
    let result = false;
    const instance = (<models.WorkflowTemplateVM_PM>this.parent['parentWorkflow']?.workflowInstance);
    const isLegalRepresentative = instance.StepSender.SenderQualification.isLegalRepresentative.toString() == 'true';
    if (isLegalRepresentative) {
      if (    this.item.stateRL == LegalRepresentationState.RepresentaçaoIndeferida   ) {
        result = true;
      }
    }
    return result;
  }

  onEdit(isEdit: boolean) {
    const invalidFields: string[] = [];
    const touched: string[] = [];
    if (!this.validacaoRLIndeferida()) {
      Object.keys(this.tableItemEditForm.controls).forEach(controlKey => {
        this.tableItemEditForm.controls[controlKey].markAsTouched();
        if (this.tableItemEditForm.controls[controlKey].invalid) {
          invalidFields.push(controlKey);
        }
        if (!this.tableItemEditForm.controls[controlKey].touched) {
          touched.push(controlKey);
        }
      })
      if (invalidFields.length > 0) {
        console.table(invalidFields);
        this.scrollToFirstInvalidControl(invalidFields);
        return;
      }
    } else {
      super.onRemove(false);
      return;
    }


    //PersonType
    this.item.personTypology = this.personType.personTypology;
    this.item.personTypologyCode = this.personType.personTypologyCode;

    //BenefitType
    this.item.funeralAllowanceBenefit = this.benefitType.funeralAllowanceBenefit;
    this.item.reimbursementFuneralBenefit = this.benefitType.reimbursementFuneralBenefit;
    this.item.survivalPensionBenefit = this.benefitType.survivalPensionBenefit;
    this.item.SSReceived = this.benefitType.SSReceived;
    this.item.SSDiscounts = this.benefitType.SSDiscounts;
    this.item.livedWithDeceased = this.benefitType.livedWithDeceased;
    this.item.funeralExpense = this.benefitType.funeralExpense;

    //BeneficiaryIdentification
    this.item.beneficiaryName = this.beneficiaryIdentification.beneficiaryName;
    this.item.dateOfBirth = this.beneficiaryIdentification.dateOfBirth;
    this.item.nationality= this.beneficiaryIdentification.nationality;
    this.item.gender = this.beneficiaryIdentification.gender;
    this.item.civilStateDeathDate = this.beneficiaryIdentification.civilStateDeathDate;
    this.item.civilState = this.beneficiaryIdentification.civilState;
    this.item.identificationDocumentType = this.beneficiaryIdentification.identificationDocumentType;
    // Remover zeros à esquerda do número de identificação caso o tipo de documento seja BI
    if (this.item.identificationDocumentType == 'B') {
      this.item.identificationNumberFirst = this.beneficiaryIdentification.identificationNumberFirst?.replace(/^0+/, '');
    } else {
      this.item.identificationNumberFirst = this.beneficiaryIdentification.identificationNumberFirst;
    }

    this.item.identificationNumberLast = this.beneficiaryIdentification.identificationNumberLast;
    this.item.NIF = this.beneficiaryIdentification.NIF;
    this.item.NISS = this.beneficiaryIdentification.NISS;
    this.item.financialService = this.beneficiaryIdentification.financialService;
    this.item.financialServiceLast = this.beneficiaryIdentification.financialServiceLast;

    //BeneficiaryContacts
    this.item.countryCode = this.beneficiaryContacts.countryCode;
    this.item.address = this.beneficiaryContacts.address?.toUpperCase();
    this.item.postalCodeFirst = this.beneficiaryContacts.postalCodeFirst;
    this.item.postalCodeLast = this.beneficiaryContacts.postalCodeLast;
    this.item.postalCodeFull = this.beneficiaryContacts.postalCodeFull;
    this.item.postalDesignation = this.beneficiaryContacts.postalDesignation;
    this.item.locality = this.beneficiaryContacts.locality?.toUpperCase();
    this.item.telephone = this.beneficiaryContacts.telephone;
    this.item.mobileNumber = this.beneficiaryContacts.mobileNumber;
    this.item.email = this.beneficiaryContacts.email;

    //DeceasedRelationship
    this.item.deceasedRelationship = this.deceasedRelationship.deceasedRelationship;
    this.item.otherDeceasedRelationship = this.deceasedRelationship.otherDeceasedRelationship;
    this.item.startDateCohabitation = this.deceasedRelationship.startDateCohabitation;
    this.item.marriageDate = this.deceasedRelationship.marriageDate;
    this.item.hasCourtAlimony = this.deceasedRelationship.hasCourtAlimony;
    this.item.alimonyValueDeathDate = this.deceasedRelationship.alimonyValueDeathDate;
    this.item.hasChargeDeceased = this.deceasedRelationship.hasChargeDeceased;
    this.item.monthlyncome = this.deceasedRelationship.monthlyncome;
    this.item.hasIRSExemption = this.deceasedRelationship.hasIRSExemption;
    this.item.scholarSituationDeathDate = this.deceasedRelationship.scholarSituationDeathDate;
    this.item.educationLevelDeathDate = this.deceasedRelationship.educationLevelDeathDate;
    this.item.registrationYear = this.deceasedRelationship.registrationYear;
    this.item.activeProfessionalSituation = this.deceasedRelationship.activeProfessionalSituation;
    this.item.startDateProfession = this.deceasedRelationship.startDateProfession;
    this.item.income = this.deceasedRelationship.income;
    this.item.professionalSituation = this.deceasedRelationship.professionalSituation;
    this.item.hasIncapacity = this.deceasedRelationship.hasIncapacity;
    this.item.hasSocialPension = this.deceasedRelationship.hasSocialPension;
    this.item.socialPensionDate = this.deceasedRelationship.socialPensionDate;
    this.item.hasJudicialInterdiction = this.deceasedRelationship.hasJudicialInterdiction;

    //legalRepresentationIdentification
    this.item.hasLegalRepresentation = this.legalRepresentationIdentification.hasLegalRepresentation;
    this.item.legalRepresentationName = this.legalRepresentationIdentification.legalRepresentationName;
    this.item.representationType = this.legalRepresentationIdentification.representationType;
    //This two lines below should be commented because stateRL is a read only property
    this.item.stateRL = this.legalRepresentationIdentification.stateRL;
    this.item.rejectionReason = this.legalRepresentationIdentification.rejectionReason;

    //taxInformation
    this.item.irsTable = this.taxInformation.irsTable;
    this.item.irsTableCode = this.taxInformation.irsTableCode;
    this.item.desvalorizationPercentage = this.taxInformation.desvalorizationPercentage!=null? parseFloat(this.taxInformation.desvalorizationPercentage.toString()):null;
    this.item.revenueTitularityCode = this.taxInformation.revenueTitularityCode;
    this.item.entireRatePerOption = this.taxInformation.entireRatePerOption!=null? parseFloat(this.taxInformation.entireRatePerOption.toString()):null;
    this.item.dependentsWithoutDisability = this.taxInformation.dependentsWithoutDisability;
    this.item.dependentsWithDisability = this.taxInformation.dependentsWithDisability;

    //Payments
    this.item.bankAccount = this.payment.bankAccount;
    this.item.coholderName = this.payment.coholderName;
    this.item.iban = this.payment.iban;
    this.item.isSoleHolder = this.payment.isSoleHolder;

    //beneficiaryObservations
    this.item.additionalObservations = this.beneficiaryObservations.additionalObservations;

    //notifications
    this.item.emailNotification = this.notifications.emailNotification;

    const instancia = (<models.WorkflowTemplateVM_PM>this.parent['parentWorkflow']?.workflowInstance)
    const deathDate = instancia.StepDeceased.DeceasedIdentification.deathDate;
    const hadPensionCGABeforeDeath = instancia.StepDeceased.ProfessionalCategory.hadPensionCGABeforeDeath;
    const nameOfDeceased = instancia.StepDeceased.DeceasedIdentification.subscriberName;
    const nifOfDeceased = instancia.StepDeceased.DeceasedIdentification.NIF;
    const existePensaoSobrevivencia = this.itemList.filter(el => el.survivalPensionBenefit?.toString() == 'true').length > 0;
    //notificações dos documentos
    const legalRepresentativeIsNotSender = !instancia.StepSender.SenderQualification.isLegalRepresentative;
    if (this.tableItemEditForm.valid) {
      this.BeneficiaryHelperService.docProvaEfectividadeChange(false, existePensaoSobrevivencia, hadPensionCGABeforeDeath, nameOfDeceased, nifOfDeceased);
      this.BeneficiaryHelperService.docFaturaOuReciboChange(false, this.item);
      this.BeneficiaryHelperService.docCerNascimentoReqChange(false, this.item);
      this.BeneficiaryHelperService.docAtestadoJuntaFreguesiaChange(false, this.item);
      this.BeneficiaryHelperService.docDeclCompHonraChange(false, this.item);
      this.BeneficiaryHelperService.docProvaEscolarChange(false, this.item, deathDate);
      this.BeneficiaryHelperService.docComprovativoSSChange(false, this.item);
      this.BeneficiaryHelperService.docSentencaChange(false, this.item);
      this.BeneficiaryHelperService.docDeclaracaoIRSChange(false, this.item);
      this.BeneficiaryHelperService.docDeclaracaoPensaoAlimentosChange(false, this.item);
      this.BeneficiaryHelperService.docPrestacoesFamiliaresChange(false, this.item);
      this.BeneficiaryHelperService.docPSIChange(false, this.item);
      this.BeneficiaryHelperService.docCertidaoIsensaoIRSChange(false, this.item);
      this.BeneficiaryHelperService.docComprovativoIBANChange(false, this.item);
      this.BeneficiaryHelperService.docRequerenteHabilitadoChange(false, this.item, this.isServiceOrFunerary);
      this.BeneficiaryHelperService.docBeneficiaryRepresentacaoLegalChange(false, this.item, this.isServiceOrFunerary, legalRepresentativeIsNotSender);
      this.BeneficiaryHelperService.docBeneficiaryRepresentacaoLegalCertidaoChange(false, this.item, this.isServiceOrFunerary, legalRepresentativeIsNotSender);
    }

    //Notificação dos campos :
    //-"Relação com o falecido"
    if (this.nifValidationService.isPessoaSingularNif(this.item.NIF)) {
      if (!DateHelpers.isAdult(this.item?.dateOfBirth)) {
        if (this.isServiceOrFunerary?.toString() == 'true') {
          // É Serviço
          if (this.item.hasLegalRepresentation?.toString() == 'true') {
            //Tem representação legal não mostra a mensagem 
          } else {
            //Não tem representação legal mostra a mensagem do serviço
            let message = "PrestacoesMorte.Modals.DeceasedRelationship.ChildrenLegalAgeWarningService";
            var confirmDeleteModal = <models.BaseModalVM>{
              isError: false,
              message: message,
              cancelButton: {
                hideButton: true,
                buttonText: "Ok",
                buttonClass: 'btn-primary',
                iconClass: "icon-check"
              }
            };
            return this.modalService.showModals([confirmDeleteModal]).subscribe(resultSubscribe => {
            });
          }
        } else {
          // É habilitando
          if (this.item.hasLegalRepresentation?.toString() != 'true') {
            //Não tem representação legal mostra a mensagem do habilitando
            const message = "PrestacoesMorte.Modals.DeceasedRelationship.ChildrenLegalAgeWarningHabilitando";
            var confirmDeleteModal = <models.BaseModalVM>{
              isError: false,
              message: message,
              cancelButton: {
                hideButton: true,
                buttonText: "Ok",
                buttonClass: 'btn-primary',
                iconClass: "icon-check"
              }
            };
            return this.modalService.showModals([confirmDeleteModal]).subscribe(resultSubscribe => {
            });
          }
        }
      }


    }

    //Notificação dos campos :
    //-"Vivia em comunhão de mesa e habitação com falecido?"
    //-"Valor da despesa de funeral."
    //-"Estado civil na data de óbito"
    //-"Relação com o falecido"
    //-"Recebe pensão de alimentos homologada judicialmente?"
    //-"Encontra-se a cargo do falecido"
    //-"Ano de matricula"
    //-"Valor que aufere"
    //-"É beneficiário da pensão social para a inclusão ou de prestações familiares?"

    const yearOfDeceased =deathDate?.getFullYear();
    if ((this.item?.livedWithDeceased?.toString().toLowerCase() == 'false') ||
      (this.item?.funeralExpense > this.IASValue * 3) ||
      (this.item?.civilStateDeathDate != this.maritalStatusValues.Casado && this.item?.deceasedRelationship == this.relationDeceasedValues.Conjugue ) ||
      (this.item?.civilStateDeathDate != this.maritalStatusValues.Divorciado && this.item?.deceasedRelationship == this.relationDeceasedValues.ExConjugue) ||
      (this.item?.civilStateDeathDate == this.maritalStatusValues.Casado && this.item?.deceasedRelationship == this.relationDeceasedValues.UniaoDeFacto) ||
      (this.item?.deceasedRelationship == this.relationDeceasedValues.Outros && (this.item?.survivalPensionBenefit == true || this.item?.funeralAllowanceBenefit == true)) ||
      (this.item?.hasCourtAlimony?.toString() == "false") ||
      (this.item?.hasChargeDeceased?.toString() == "false") ||
      (isNotNullOrUndefinedOrEmpty(this.item.registrationYear) && yearOfDeceased != this.item.registrationYear) ||
      (this.item?.income > this.RMMG) ||
      (this.item?.hasSocialPension?.toString() == "false") && this.item?.deceasedRelationship == this.relationDeceasedValues.Filhos
        && DateHelpers.isAdult(this.item?.dateOfBirth)
      ) {
      var confirmDeleteModal = <models.BaseModalVM>{
        isError: false,
        message: "PrestacoesMorte.Modals.RequestRejectedWarning",
      };
      //return this.modalService.showModals([confirmDeleteModal]).subscribe(resultSubscribe => {
      //  if (resultSubscribe == true) {
      //    super.markTouched();

      //    super.onEdit(isEdit);
      //  }
      //  return;
      //})
    }



    //Notificação dos campos :
    //-"Conta bancária"

    if (this.item?.countryCode == "PT" && this.item?.bankAccount == "I") {
      var confirmDeleteModal = <models.BaseModalVM>{
        isError: false,
        message: "PrestacoesMorte.Modals.BankAccount.InternationalBankAccountWarning",
      };
      return this.modalService.showModals([confirmDeleteModal]).subscribe(resultSubscribe => {
        if (resultSubscribe == true) {
          super.markTouched();

          super.onEdit(isEdit);
        }
      })
    }

    super.markTouched();

    super.onEdit(isEdit);
  }

  removeFromList(currentList: any[], event: MouseEvent) {
    const indexToRemove = this.itemList.findIndex(b => b.beneficiaryID == this.item.beneficiaryID)
    const instancia = (<models.WorkflowTemplateVM_PM>this.parent['parentWorkflow']?.workflowInstance)
    const deathDate = instancia.StepDeceased.DeceasedIdentification.deathDate;
    const hadPensionCGABeforeDeath = instancia.StepDeceased.ProfessionalCategory.hadPensionCGABeforeDeath;
    const nameOfDeceased = instancia.StepDeceased.DeceasedIdentification.subscriberName;
    const nifOfDeceased = instancia.StepDeceased.DeceasedIdentification.NIF;
    const existePensaoSobrevivencia = this.itemList.filter(el => el.survivalPensionBenefit?.toString() == 'true').length > 0;
    const legalRepresentativeIsNotSender = !instancia.StepSender.SenderQualification.isLegalRepresentative;
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      confirmRemoveFromList(currentList, indexToRemove, this.modalService).subscribe(result => {
        if (result) {
          this.BeneficiaryHelperService.docProvaEfectividadeChange(true, existePensaoSobrevivencia, hadPensionCGABeforeDeath, nameOfDeceased, nifOfDeceased);
          this.BeneficiaryHelperService.docFaturaOuReciboChange(true, this.item);
          this.BeneficiaryHelperService.docCerNascimentoReqChange(true, this.item);
          this.BeneficiaryHelperService.docAtestadoJuntaFreguesiaChange(true, this.item);
          this.BeneficiaryHelperService.docDeclCompHonraChange(true, this.item);
          this.BeneficiaryHelperService.docProvaEscolarChange(true, this.item, deathDate);
          this.BeneficiaryHelperService.docComprovativoSSChange(true, this.item);
          this.BeneficiaryHelperService.docSentencaChange(true, this.item);
          this.BeneficiaryHelperService.docDeclaracaoIRSChange(true, this.item);
          this.BeneficiaryHelperService.docDeclaracaoPensaoAlimentosChange(true, this.item);
          this.BeneficiaryHelperService.docPrestacoesFamiliaresChange(true, this.item);
          this.BeneficiaryHelperService.docPSIChange(true, this.item);
          this.BeneficiaryHelperService.docCertidaoIsensaoIRSChange(true, this.item);
          this.BeneficiaryHelperService.docComprovativoIBANChange(true, this.item);
          this.BeneficiaryHelperService.docRequerenteHabilitadoChange(true, this.item, this.isServiceOrFunerary);
          this.BeneficiaryHelperService.docBeneficiaryRepresentacaoLegalChange(true, this.item, this.isServiceOrFunerary, legalRepresentativeIsNotSender);
          this.BeneficiaryHelperService.docBeneficiaryRepresentacaoLegalCertidaoChange(true, this.item, this.isServiceOrFunerary, legalRepresentativeIsNotSender);


        }

      });
    }
    event.stopPropagation();
  }

  onRemove(isEdit: boolean) {
    super.markTouched()

    super.onRemove(isEdit);

  }

  public removeTrashButton() {
    if (this.parent['parentWorkflow']?.workflowInstance.StepSender.SenderQualification?.isBeneficiary &&
      this.item.NIF== this.parent['parentWorkflow']?.workflowInstance.StepSender.SenderIdentification.NIF) {
      return false
    } else {
      return true
    }
  }

  private scrollToFirstInvalidControl(arrayOfInvalid: string[]) {
    //const firstInvalidControl: HTMLElement = this.elementRef.nativeElement.querySelector(
    //  "form .ng-invalid  .invalid-feedback"
    //);

    const firstInvalidControl: HTMLElement = document.getElementsByName(arrayOfInvalid[0])?.[0];


    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });

    fromEvent(window, "scroll")
      .pipe(
        debounceTime(100),
        take(1)
    )
      .toPromise().then(() => firstInvalidControl.focus());
  }

  private getTopOffset(controlEl: HTMLElement): number {
    if (controlEl == null) {
      return;
    }
    const labelOffset = 150;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;

 
  }
}
